<template>
  <ym-popup class="popup"
            v-model="visible"
            get-container="body"
            position="center"
  >
    <slot>
      <div class="popup-container"
           @click="handleClose"
      >
        课程将会自动赠送至您的账户中<br>欢迎下载“少年商学院”APP<br>进入“学习”页面查看
      </div>
    </slot>
  </ym-popup>
</template>

<script>
  import { Popup } from '@ymba/ym-ui';

  export default {
    name: 'BirthdayGiftPopup2021',
    components: {
      'ym-popup': Popup,
    },
    data() {
      return {
        visible: false,
      };
    },
    props: {
      show: {
        type: Boolean,
        required: true,
      },
    },
    watch: {
      show(val) {
        this.visible = val;
      },
      visible(val) {
        this.$emit('update:show', val);
      },
    },
    methods: {
      handleClose() {
        this.visible = false;
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .popup {
    background: none;
  }

  .popup-container {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 100px;
    box-sizing: border-box;
    width: 750px;
    height: 680px;
    background: url('~@/pages/2021/Birthday/assets/img/gift_popup.png');
    background-size: 100% 100%;
    color: #fa405e;
    font-size: 30px;
    text-align: center;
  }
</style>
